

export default class HttpHelpers
{

    static HttpStatusOk(httpStatus)
    {
        return (httpStatus >= 200 && httpStatus < 300); 
    }
}